'use strict';

/**
 *  Load modules
 */
// import './modules/hyphenator';
import './modules/browser-detect';
import './modules/slider';
import './modules/masonry';
import './modules/scripts';
import './modules/sponsor-scripts';
import './modules/rest_api';
import './modules/table-filter';
import './modules/form';
import './modules/fancybox';
import './modules/tooltipster';
import '../scss/app.scss';
$(document).ready(function () {});